"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map = _interopRequireDefault(require("unmutable/lib/map"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default(parcelType, methodCreator) {
  return function (parcel) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var methods = methodCreator.apply(void 0, [parcel].concat(args)); // $FlowFixMe - I want to do this

    if (parcel["is".concat(parcelType)]()) {
      return methods;
    }

    return (0, _pipeWith.default)(methods, (0, _map.default)(function (value, key) {
      return function () {
        // $FlowFixMe - why do you pay attention to your types more than preceding conditional logic?
        var suffix = Array.isArray(parcel.path) ? "(keyPath: [".concat(parcel.path.join(', '), "]).") : "";

        if (key.slice(-4) === "Self") {
          throw new Error(".".concat(key.slice(0, -4), "() cannot be called with ").concat(arguments.length, " arguments on a value of \"").concat(parcel.value, "\". ").concat(suffix));
        }

        throw new Error(".".concat(key, "() is not a function. It can only be called on parcels of type \"").concat(parcelType, "\". ").concat(suffix));
      };
    }));
  };
};

exports.default = _default;